import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV164({ createClickableListItem, createThumbnail }) {
  return (
    <ReleaseCard version="v1.6.4" date="15th October 2025" title="The features keep coming!">
      <p className="text-gray-300 mb-4">Looking back at version 1.0.0, we were thrilled with our achievements. Since then, we've added over 50 new features and enhancements, which have amazed us. We especially enjoy incorporating your requests. Remember, the main USP of Poppy Poker is the ability to alert all connected devices simultaneously about any level changes; everything else is a bonus - nobody else has achieved this as well as we have, it was a hard nut to crack but we cracked it, we're leading the way!</p>
      <p className="text-gray-300 mb-4">Here are a few highlights from the latest version:</p>
      <ul className="text-gray-400 space-y-2 mb-4">
        {createClickableListItem('Added forgotten password functionality for manual logins', '/v1.6.4/forgotPassword.jpg')}
        <li>• Reworked app upgrade message mechanism</li>
        {createClickableListItem('Added link to Venue from the game detail page', '/v1.6.4/linkToVenue.jpg')}
        <li>• Improved several layouts</li>
        <li>• Removed the test inn from the list of venues</li>
      </ul>
      <div className="mb-4">
        <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
        <div className="flex flex-wrap gap-4">
          {createThumbnail('/v1.6.4/forgotPassword.jpg', 'Forgotten password functionality for manual logins feature preview')}
          {createThumbnail('/v1.6.4/linkToVenue.jpg', 'Link to Venue from the game detail page feature preview')}
        </div>
      </div>
      <p className="text-purple-400 font-medium">We can't thank you enough—keep the feedback coming, whether good or bad. It only makes Poppy Poker better!</p>
    </ReleaseCard>
  );
}
